(function ($) {
  Drupal.behaviors.desire_video = {
    attach: function (context) {
      $('#desire_mod2', context).once(function (idx, element) {
        var $module = $(element),
          $videoWrapper = $module.find('.desire_mod2__video-wrapper'),
          $video = $videoWrapper.find('video'),
          $videoPoster = $videoWrapper.find('.desire_mod2__poster'),
          $captionsWrapper = $videoWrapper.find('.desire_mod2__video-captions'),
          $captions = $captionsWrapper.find('.video-caption');
        var timecodes = [],
          reqAnimFrame,
          smScene,
          smController,
          hasAnimatedIn = false,
          moduleBackground = $module.data('module-background') || 'dark',
          moduleWillFade = $module.data('scrollmagic') || false,
          moduleOffset = $module.data('scrollmagic-offset') || 0;

        function init() {
          prepareIntroAnimation();
          prepareTimecodes();
          setModuleBackground();
          bindEvents();
        }

        /**
         * Setup scroll magic to trigger the video autoplay when it's scrolled in
         */
        function prepareIntroAnimation() {
          if (moduleWillFade) {
            $module.parent().addClass('hideModules'); // hide it first
          }

          smController = new ScrollMagic.Controller();

          smScene = new ScrollMagic.Scene({
            triggerElement: '#desire_mod2',
            offset: moduleOffset
          }).addTo(smController)
            .on('start', function (e) {
              animateInModule(); // animate module
              $video.get(0).play(); // initialize video playback
            });
        }

        /**
         * Animate the appearing of this module
         */
        function animateInModule() {
          if (!hasAnimatedIn) {
            $module.parent('.el_boutique_wrapper').animate({
              opacity: 1,
              paddingTop: '0'
            }, 350, 'easeOutQuad');
            hasAnimatedIn = true;
          }
        }

        /**
         * Apply a css class to the module wrapper based on background in data-module-background
         */
        function setModuleBackground() {
          $module.parent().parent().addClass('desire__module-' + moduleBackground + '-bg');
        }

        /**
         * Gather timecodes from the captions in the html
         */
        function prepareTimecodes() {
          $captions.each(function (idx) {
            var tc = $captions.eq(idx).data('timecodes').split('|');

            timecodes.push({
              caption: $captions.eq(idx),
              start: Number(tc[0]),
              end: Number(tc[1])
            });
          });
        }

        /**
         * Compares if the currentTime is within the start and end values of the timecode
         *
         * @param currentTime Current video time in miliseconds
         * @param timecode The timecode object (e.g., { start: 1000, end: 3000 })
         * @returns {boolean}
         */
        function isCaptionInCurrentTime(currentTime, timecode) {
          return timecode.start <= currentTime && currentTime <= timecode.end;
        }

        /**
         * Hides/shows the current caption according to the current time of the video
         *
         * @param currentTime The current video time in miliseconds
         */
        function updateCaptions(currentTime) {
          var found = _.find(timecodes, _.partial(isCaptionInCurrentTime, currentTime));

          if (found) {
            $captions.not(found.caption).removeClass('show');
            if (!found.caption.hasClass('show')) {
              found.caption.addClass('show');
            }
          } else {
            $captions.removeClass('show');
          }
        }

        /**
         * Hide the video initial image when the video reaches 1800ms of playtime
         * avoids the strange initial fade-in on first play
         */
        function hideVideoPoster(currentTime) {
          if (currentTime > 1800 && $videoPoster.hasClass('faded-out') === false) {
            $videoPoster.addClass('faded-out');
          }
        }

        /**
         * Initialize the tracking of the current video time using requestAnimationFrame
         */
        function startCaptionsTracking() {
          reqAnimFrame = requestAnimationFrame(function play() {
            var currentTime = Math.round($video.get(0).currentTime * 1000); // $video.get(0) as we need the node and not the jquery object

            updateCaptions(currentTime);
            hideVideoPoster(currentTime);
            reqAnimFrame = requestAnimationFrame(play);
          });
        }

        /**
         * Stop the tracking of the current video time
         */
        function stopCaptionsTracking() {
          if (reqAnimFrame) {
            cancelAnimationFrame(reqAnimFrame);
          }
        }

        /**
         * Bind events to DOM
         */
        function bindEvents() {
          $video.on('play', startCaptionsTracking);
          $video.on('pause', stopCaptionsTracking);
        }

        init();
      });
    }
  };
})(jQuery);
